export default __webpack_public_path__ + "static/media/split-bill-step-1.5a6328c4.png";